import type { Components, Theme } from '@mui/material';

import { colors } from '../tokens';

export const MuiPaginationItem: Components<Theme>['MuiPaginationItem'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 8,
      color: colors.gray[500],
      ...theme.applyStyles('dark', {
        color: colors.black[200],
      }),
      '&.Mui-selected': {
        backgroundColor: colors.gray[50],
        color: colors.black[700],
        '&:hover': {
          backgroundColor: '#E8E9EC',
        },
        ...theme.applyStyles('dark', {
          backgroundColor: colors.black[850],
          color: colors.black[100],
          '&:hover': {
            backgroundColor: colors.black[700],
          },
        }),
      },
    }),
  },
};
